<template>
  <div class="answer-screen" >
    <div id="wrapper-survey-answer" v-if="survey && participant && !submited">
      <div v-if="survey.questions.length > 0 && currentQuestion === null">
        <div v-if="survey.questions.length > 0 && currentQuestion === null">
          <div class="content-body welcome" v-if="survey.$scopQuestionnaire">
            Bonjour,<br><br>

            Comme l'ensemble des sociétés coopératives, Acome, en tant que SCOP, doit obligatoirement effectuer l’audit coopératif afin de pouvoir obtenir son agrément ministériel.<br><br>

            ARESCOP, l’Association de Révision des Sociétés Coopératives, mise en place par la Confédération Générale des SCOP, a été retenue pour conduire cette mission.<br><br>

            Un des objectifs de la révision coopérative est d'apprécier votre perception de la vie coopérative et de son fonctionnement au sein d‘Acome.<br><br>

            Dans ce cadre, nous adressons un questionnaire à l'ensemble des associés d’Acome. Cette enquête est ANONYME et a pour but de faire ressortir des éléments dominants et non des prises de positions individuelles. C'est donc en toute confiance que nous devrons travailler ensemble.<br><br>

            Nous vous remercions de bien vouloir consacrer du temps à ce moment d’expression important dans la vie de votre coopérative et de contribuer ainsi à l'audit que nous entreprenons.<br><br>

            En tant que salarié, si vous n’êtes pas encore associé, vous n’aurez pas accès aux questions de la Révision coopérative mais serez renvoyé directement à l’enquête relative à la Qualité de Vie au Travail (QVT).<br><br>
            Ce questionnaire peut comporter jusqu'à {{ survey.questions.length }} questions.
          </div>
          <div class="content-body welcome" v-else>
            Bonjour, vous allez répondre à une enquête de façon anonyme.<br><br>
            Cette enquête {{ survey.scopQuestionnaire ? `peut comprter jusqu'à` : `comporte` }} {{ survey.questions.length }} questions et ne vous prendra que peu de temps.<br><br>
            Nous comptons sur vous pour avoir une vision la plus objective possible.<br><br>
            Cliquez sur "Commencer" quand vous êtes prêt.
          </div>
        </div>
        <div class="text-center">
          <v-btn large flat v-on:click.native="start" class="answers-buttom elevation-0 deep-purple accent-2 white--text">Commencer</v-btn>
        </div>
      </div>

      <div
        v-else-if="currentQuestion"
        style="position: absolute; top: 140px; right: 0; bottom: 0; left: 0; text-align: center;"
      >
        <div>
          <div v-if="getCategory(currentQuestion)" class="category">
            {{getCategory(currentQuestion)}}
          </div>
          <h1 class="question-label" :style="`margin-top: ${currentQuestion.questionnaire ? `40` : `100`}px;`">
            {{ currentQuestion.label }}
          </h1>
          <h2 class="question-sub-label">
            {{ currentQuestion.subLabel }}
          </h2>
        </div>
        <div v-if="currentQuestion.questionnaire">
          <v-layout row text-xs-center>
            <v-flex></v-flex>
            <v-flex xs10 text-xs-center>
              <question @next="nextQuestion" />
            </v-flex>
            <v-flex></v-flex>
          </v-layout>
        </div>
        <div v-else>
          <div class="pb-4 mb-4 survey-answer-happiness-wrapper">
            <div class="survey-answer-happiness">
              <div :class="['happiness-btn', 'survey-answer-happiness-1', { selected: currentScore === 0 }]" v-on:click="answer(0)">
                <div class="halo"></div>
                <!-- <v-icon  dark>sentiment_very_dissatisfied</v-icon> -->
                <v-icon dark>sentiment_dissatisfied</v-icon>
              </div>
              <div :class="['happiness-btn', 'survey-answer-happiness-2', { selected: currentScore === 1 }]" v-on:click="answer(1)">
                <div class="halo"></div>
                <!-- <v-icon dark>sentiment_dissatisfied</v-icon> -->
              </div>
              <div :class="['happiness-btn', 'survey-answer-happiness-3', { selected: currentScore === 2 }]" v-on:click="answer(2)">
                <div class="halo"></div>
                <!-- <v-icon dark>sentiment_neutral</v-icon> -->
              </div>
              <div :class="['happiness-btn', 'survey-answer-happiness-4', { selected: currentScore === 3 }]" v-on:click="answer(3)">
                <div class="halo"></div>
                <!-- <v-icon dark>sentiment_satisfied</v-icon> -->
              </div>
              <div :class="['happiness-btn', 'survey-answer-happiness-5', { selected: currentScore === 4 }]" v-on:click="answer(4)">
                <div class="halo"></div>
                <!-- <v-icon dark>sentiment_very_satisfied</v-icon> -->
                <v-icon dark>sentiment_satisfied</v-icon>
              </div>
            </div>
          </div>

          <div class="answer-confirm pt-4 mt-4" v-if="!currentQuestion.isVerbatim">
            <div class="mt-4">
              <v-btn class="answers-buttom elevation-0 deep-purple accent-2 white--text" large flat v-on:click.native="confirmAnswer" :style="{ opacity: currentScore === null ? 0 : 1, }">Valider</v-btn>
            </div>
          </div>
        </div>
        <div v-if="currentQuestion.isVerbatim && currentScore !== null" class="survey-answer-verbatim">
          <v-text-field
            :placeholder="currentQuestion.verbatimHelper || `Apportez des précisions sur votre réponse ici...`"
            multi-line
            v-model="currentVerbatim"
          ></v-text-field>
          <p style="text-align:left;">
            {{ maxVerbatimLength }} caractères maximum
            <span style="color:green;" v-if="currentVerbatim.length <= 250">({{ maxVerbatimLength - currentVerbatim.length }} restant)</span>
            <span style="color:red;" v-else>({{ currentVerbatim.length }} utilisés)</span>.
          </p>
          <div class="survey-answer-verbatim-button-wrapper">
            <v-btn class="answers-buttom elevation-0 deep-purple accent-2 white--text" large flat v-on:click.native="answerVerbatim" :disabled="currentVerbatim.length > maxVerbatimLength">Valider</v-btn>
          </div>
        </div>

        <div class="answer-footer-wrapper">
          <div class="answer-footer progress">
            {{ currentQuestion.index + 1 }}/{{ survey.questions.length }}
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="submited">
      <div class="content-body welcome">
          Merci d'avoir répondu ! Vous pouvez passer la tablette à la personne suivante après avoir cliqué sur "Terminer", à bientôt !
      </div>
      <div class="text-center">
        <v-btn large flat v-on:click.native="goToHome" class="answers-buttom elevation-0 deep-purple accent-2 white--text">Terminer</v-btn>
      </div>
    </div>
    <div v-else>Pas de données de particpant ni de diagnostic</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Question from './additional/Question';
import _ from "lodash";

export default {
  name: `answerscreen`,
  components: {
    Question,
  },
  data () {
    return {
      isSubmitting    : false,
      isFailed        : false,
      isSucceeded     : false,
      currentScore    : null,
      currentVerbatim : ``,
      maxVerbatimLength: 250,
      submited: false,
    };
  },
  mounted () {
    this.currentQuestion = null;
  },
  methods: {
    getCategory (question) {
      return Boolean(question.data) && _.isInteger(question.data.category) ? this.survey.$scopQuestionnaire.data.categories[question.data.category] : null;
    },
    start () {
      this.currentQuestion = this.survey.questions[0];
    },
    nextQuestion () {
      const nextQuestionIndex    = this.survey.questions.indexOf(this.currentQuestion) + 1;
      if (nextQuestionIndex >= this.survey.questions.length) {
        return this.submitSurvey();
      }
      let canContinue = false;
      if (this.currentQuestion.questionnaire && this.currentQuestion.data.skipAdditionnalQuestionnaireIf && this.currentQuestion.additionalAnswer === this.currentQuestion.data.choices[this.currentQuestion.data.skipAdditionnalQuestionnaireIf]) {
        this.currentQuestion = _.find(this.survey.questions, q => !q.questionnaire);
        return;
      }
      this.currentQuestion = this.survey.questions[nextQuestionIndex];
      if (this.currentQuestion.questionnaire && this.currentQuestion.data.conditions && this.currentQuestion.data.conditions.length > 0) {
        for (const condition of this.currentQuestion.data.conditions) {
          const conditionQuestion = _.find(this.currentSurvey.questions, { id: condition.question });
          if (_.isArray(conditionQuestion.additionalAnswer)) {
            if (conditionQuestion.data.otherChoice && condition.answerIndex === conditionQuestion.data.choices.length) {
              if (!_.find(conditionQuestion.additionalAnswer, answer => {
                return answer.split(` :`)[0] === conditionQuestion.data.otherLabel;
              })) {
                canContinue = true;
              }
            }
            if (conditionQuestion.additionalAnswer.includes(conditionQuestion.data.choices[condition.answerIndex])) {
              canContinue = true;
            }
          } else {
            if (conditionQuestion.data.otherChoice && condition.answerIndex === conditionQuestion.data.choices.length) {
              if (conditionQuestion.additionalAnswer.split(` :`)[0]  === conditionQuestion.data.otherLabel) {
                canContinue = true;
              }
            }
            if (conditionQuestion.additionalAnswer === conditionQuestion.data.choices[condition.answerIndex]) {
              canContinue = true;
            }
          }
          if (!canContinue) {
            return this.nextQuestion();
          }
        }
      }
    },
    confirmAnswer () {
      this.currentQuestion.score = this.currentScore;
      this.currentScore          = null;
      this.nextQuestion();
      return null;
    },
    answer (score) {
      this.currentScore = score;
    },
    answerVerbatim () {
      this.currentQuestion.verbatim = this.currentVerbatim;
      this.currentVerbatim = ``;
      this.confirmAnswer();
    },
    submitSurvey () {
      this.$store.dispatch(`saveCurrentAnswers`);
      this.submited = true;
    },
    goToHome() {
      this.$router.replace(`/choose/participant`);
    },
  },
  computed: {
    ...mapState({
      participant : `currentParticipant`,
      survey      : `currentSurvey`,
      rawCurrentQuestion: `currentQuestion`,
      currentSurvey: `currentSurvey`,
      stagedAnswers: `stagedAnswers`,
    }),
    currentQuestion: {
      get () {
        return this.rawCurrentQuestion;
      },
      set (question) {
        this.$store.commit(`SET_CURRENT_QUESTION`, question);
      },
    },
  },
};

</script>

<style>
  .category {
    margin-top: 100px;
    background-color: #eeeeee;
    padding: 15px;
    font-size: 21px;
    font-family: 'Open-Sans', sans-serif;
    line-height: 100%;
  }

  body {
    background-color: rgb(250, 250, 250) !important;
  }
  .question {
    width: 50vw;
  }

  .top-logo {
    display : block;
    width   : 150px;
    margin  : 20px auto;
  }

  .content-body {
    margin-top    : 2rem;
    text-align    : center;
    font-size     : 2rem;
    margin-bottom : 2rem;
    line-height   : 4rem;
  }

  @media (min-width: 780px) {
    .content-body.welcome {
      line-height : 1.8rem;
      padding: 20px;
      font-size: 1.7rem;
    }

  }

  .question-label {
    font-size  : 25px;
    padding    : 0 210px;
  }

  .question-sub-label {
    font-size  : 18px;
    margin-top : 20px;
    padding    : 0 150px;
  }

  .answer-footer-wrapper0 {
    position : fixed;
    left     : 50%;
    bottom   : 60px;
  }

  .answer-footer-wrapper {
    position : relative;
    left     : initial;
    bottom   : initial;
  }
  .answer-footer {
    margin: 80px auto 40px auto;
  }

  div.nav {
    border     : 2px solid #A16790;
    background : #A16790;
    color      : #FFF;
  }
  a.nav {
    position         : absolute;
    top              : -2px;
    bottom           : -2px;
    width            : 60px;
    line-height      : 46px;
    background-color : #A16790;
    border           : 6px solid #FFF;
    box-shadow       : 0px 0px 4px 2px #8B4D86;
    color            : #FFF;
    font-weight      : bold;
    vertical-align   : middle;
    font-size        : 30px;
    border-radius    : 200px;
  }
  a.nav:hover {
    box-shadow       : 0px 0px 8px 8px #8B4D86;
    background-color : #8B4D86;
  }
  a.nav:first-child {
    left: -10px;
  }
  a.nav:last-child {
    right: -10px;
  }
  a#start-btn {
    display         : inline-block;
    padding         : 10px 20px;
    background      : #7c4dff;
    border-radius   : 2px;
    color           : #FFF;
    text-decoration : none;
    font-size       : 22px;
    margin          : 30px auto;
    box-shadow      : 0 2px 5px 0 rgba(0,0,0,.26);
  }
  a#start-btn:hover {
    background: #603dc1;
  }
  .text-center {
    text-align: center;
  }
  .answer-footer.progress {
    background-color: #7c4dff;
  }

  @media (max-width: 780px) {
    body {
      overflow-y       : auto;
      background-color : #f3f3f3;
    }
    #background-bars {
      display: none;
    }
    #wrapper-survey-answer {
      margin-bottom: 40px;
    }
    .question-label {
      font-size  : 25px;
      margin-top : 100px;
      padding    : 0 10px;
    }
    .content-body {
      margin    : 10px;
      padding   : 10px;
      font-size : 16px;
    }
    .content-body.welcome {
      background-color : #fff;
      padding          : 20px 10px;
      text-align       : left;
      box-shadow       : 0 1px 3px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12);
      border-radius    : 2px;
      line-height      : 2rem;
    }
    a#start-btn {
      display    : block;
      margin     : 20px 10px;
      box-shadow : 0 2px 5px 0 rgba(0,0,0,.26);
    }
  }

  .happiness-btn {
    color: white;
  }

  .survey-answer-happiness {
    position : relative;
    display  : block;
    margin   : 30px;
    height   : 45px;
  }
  .survey-answer-happiness > div {
    position : relative;
    float    : left;
    display  : inline-block;
    margin   : 0;
    padding  : 0;
    width    : 20%;
    height   : 60px;
    z-index  : initial;
  }
  .survey-answer-happiness > div .halo {
    position : absolute;
    top      : 0px;
    right    : 0px;
    bottom   : 0px;
    left     : 0px;
    z-index  : 10;
    display  : none;
  }
  .survey-answer-happiness > div:first-child {
    border-top-left-radius    : 100px;
    border-bottom-left-radius : 100px;
  }
  .survey-answer-happiness > div:first-child .halo {
    border-top-left-radius    : 100px;
    border-bottom-left-radius : 100px;
  }
  .survey-answer-happiness > div:last-child {
    border-top-right-radius    : 100px;
    border-bottom-right-radius : 100px;
  }
  .survey-answer-happiness > div:last-child .halo {
    border-top-right-radius    : 100px;
    border-bottom-right-radius : 100px;
  }
  .survey-answer-happiness i {
    font-size   : 45px;
    line-height : 60px;
  }
  .survey-answer-happiness .survey-answer-happiness-1 {
    background-color : #E55947;
    color            : #ffffff;
  }

  .survey-answer-happiness .selected::after {
    content      : '';
    position     : absolute;
    display      : block;
    width        : 0;
    height       : 0;
    border-style : solid;
    border-width : 0 30px 30px 30px;
    bottom       : -50px;
    left         : 50%;
    transform    : translateX(-50%);
    border-color : transparent transparent #000000 transparent;
    z-index      : 1000;
  }

  .survey-answer-happiness .survey-answer-happiness-1.selected,
  .survey-answer-happiness .survey-answer-happiness-1:hover {
    background-color : #E55947;
    color            : #FFF;
  }
  .survey-answer-happiness .survey-answer-happiness-1.selected .halo,
  .survey-answer-happiness .survey-answer-happiness-1:hover .halo {
    box-shadow : 0px 0px 4px 4px #E55947;
    border     : 1px #E55947;
    display    : block;
  }
  .survey-answer-happiness .survey-answer-happiness-2 {
    background-color : #F0A249;
    color            : #ffffff;
  }

  .survey-answer-happiness .survey-answer-happiness-2.selected,
  .survey-answer-happiness .survey-answer-happiness-2:hover {
    background-color : #F0A249;
    color            : #FFF;
  }
  .survey-answer-happiness .survey-answer-happiness-2.selected .halo,
  .survey-answer-happiness .survey-answer-happiness-2:hover .halo {
    box-shadow : 0px 0px 4px 4px #F0A249;
    border     : 1px #F0A249;
    display    : block;
  }
  .survey-answer-happiness .survey-answer-happiness-3 {
    background-color : #F7CA50;
    color            : #ffffff;
  }
  .survey-answer-happiness .survey-answer-happiness-3.selected,
  .survey-answer-happiness .survey-answer-happiness-3:hover {
    background-color : #F7CA50;
    color            : #FFF;
  }
  .survey-answer-happiness .survey-answer-happiness-3.selected .halo,
  .survey-answer-happiness .survey-answer-happiness-3:hover .halo {
    box-shadow : 0px 0px 4px 4px #F7CA50;
    border     : 1px #F7CA50;
    display    : block;
  }
  .survey-answer-happiness .survey-answer-happiness-4 {
    background-color : #E3E158;
    color            : #ffffff;
  }
  .survey-answer-happiness .survey-answer-happiness-4.selected,
  .survey-answer-happiness .survey-answer-happiness-4:hover {
    background-color : #E3E158;
    color            : #FFF;
  }
  .survey-answer-happiness .survey-answer-happiness-4.selected .halo,
  .survey-answer-happiness .survey-answer-happiness-4:hover .halo {
    box-shadow : 0px 0px 4px 4px #E3E158;
    border     : 1px #E3E158;
    display    : block;
  }
  .survey-answer-happiness .survey-answer-happiness-5 {
    background-color : #BBD04F;
    color            : #ffffff;
  }
  .survey-answer-happiness .survey-answer-happiness-5.selected,
  .survey-answer-happiness .survey-answer-happiness-5:hover {
    background-color : #BBD04F;
    color            : #FFF;
  }
  .survey-answer-happiness .survey-answer-happiness-5.selected .halo,
  .survey-answer-happiness .survey-answer-happiness-5:hover .halo {
    box-shadow : 0px 0px 4px 4px #BBD04F;
    border     : 1px #BBD04F;
    display    : block;
  }
  .answer-footer {
    position      : relative;
    width         : 70px;
    border-radius : 200px;
    color         : #FFF;
    text-align    : center;
    font-weight   : bold;
    height        : 70px;
    line-height   : 70px;
    font-size     : 20px;
  }
  .answer-footer .controls {
    position : absolute;
    top      : 0;
    right    : 0;
    bottom   : 0;
    left     : 0;
    color    : inherit;
  }
  .answer-footer .controls a {
    color     : inherit;
    margin    : -4px 10px 0 10px;
    font-size : 35px;
  }
  .answer-footer .controls a:first-child {
    float: left;
  }
  .answer-footer .controls a:last-child {
    float: right;
  }

  button.answers-buttom {
    background-color : #7c4dff;
    font-size        : 1.4rem;
    height           : 60px;
  }

  .survey-answer-verbatim {
  width: 480px;
  max-width: 100%;
  margin: auto;
  padding: 10px 10px;
  }

  .survey-answer-verbatim .survey-answer-verbatim-button-wrapper {
    text-align: right;
    margin-bottom: -20px;
  }

  .survey-answer-verbatim button {
    padding: 10px;
    background: #7c4dff;
    border: none;
    color: white;
    font-size: 20px;
    margin-top: 10px;
    cursor: pointer;
  }

  .survey-answer-happiness {
    margin-left: -230px;
    width: 460px;
  }

  .survey-answer-happiness-wrapper {
    position: relative;
    margin-left: 50%;
  }

  @media (max-width: 480px) {
    .survey-answer-happiness-wrapper {
      margin-left: 0px;
    }
    .survey-answer-happiness {
      width: 100%;
      margin-left: 0;
    }
  }

  .input-group--text-field {
    border: rgba(0,0,0,.87) 2px solid;
    padding: 1rem 1rem 0;
  }

  .input-group__details::after {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// AnswerScreen.vue?76574eb2